import { UpdateUser } from 'domain/usecases';
import { RemoteUpdateUser } from 'data/usecases';
import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';

export const makeRemoteUpdateUser = (): UpdateUser => {
  return new RemoteUpdateUser(makeApiUrl('/users/update'), makeAuthorizeHttpClientDecorator());
};
